export default "__VITE_ASSET__DttFZODg__"